export enum StatusHospital {
  IN_TREATMENT = 'in_treatment',
  AWAITING_TREATMENT = 'awaiting_treatment',
  DISCHARGED = 'discharged',
  FATAL_OUTCOME = 'fatal_outcome'
}

export const StatusHospitalTitles = {
  [StatusHospital.IN_TREATMENT]: 'Проходит лечение',
  [StatusHospital.AWAITING_TREATMENT]: 'Ожидает лечения',
  [StatusHospital.DISCHARGED]: 'Выписан',
  [StatusHospital.FATAL_OUTCOME]: 'Летальный исход'
}
